import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const accountApi = {
  switchToSubAccount(clientCnt) {
    return http.put(API_URLS.SUB_ACCOUNT_SWITCH, {query: {clientCnt}});
  },
  switchToMasterAccount() {
    return http.put(API_URLS.MASTER_ACCOUNT_SWITCHBACK, {});
  },
  getChildrenBaseInfo() {
    return http.get(API_URLS.CHILDREN_BASIC_INFO, {
      formatter(data) {
        return data.rows.map((o) => ({...o, isSub: o.parentId !== 0}));
      },
    });
  },
  getSoulPassQualification() {
    return http.get(API_URLS.SOUL_PASS_QUALIFICATIONS, {});
  },
  getSoulPassStatus() {
    return http.get(API_URLS.SOUL_PASS_STATUS, {});
  },
  postUserChildren(params = {}) {
    return http.post(API_URLS.USER_CHILDREN, {params});
  },
  getSwitchAccount() {
    return http.get(API_URLS.SWITCH_ACCOUNT, {
      formatter(data) {
        data.rows.forEach((o) => (o.isSub = o.parentId !== 0));
        return data;
      },
    });
  },
  postAccountTransferMainSub(params) {
    return http.post(API_URLS.ACCOUNT_TRANSFER_MAIN_SUB, {params});
  },
  getChildrenAssetsUta(query) {
    return http.get(API_URLS.CHILDREN_ASSETS_UTA, {query});
  },
  getChildrenAssetsV2(query) {
    return http.get(API_URLS.CHILDREN_ASSETS_V2, {query});
  },
  getChildrenAssets(query) {
    return http.get(API_URLS.CHILDREN_ASSETS, {query});
  },
};
